module.exports = "<span class=js-fullName>{{name}}</span>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/memberSelect/templates/listItem.hbs
// module id = 665
// module chunks = 0